import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const STATE_PATH = "/master/v1/state";

export const getStateApi = async (params) =>
  await getRequest(STATE_PATH, params);

export const getStateByIdApi = async (id) =>
  await getRequest(`${STATE_PATH}/${id}`);

export const addStateApi = async (body) => await postRequest(STATE_PATH, body);

export const updateStateApi = async (body) =>
  await putRequest(`${STATE_PATH}/${body?._id}`, body);

export const deleteStateByIdApi = async (id) =>
  await deleteRequest(`${STATE_PATH}/${id}`);
